import { includes } from 'lodash';
import moment from 'moment';
import { getTourEnd, getTourStart } from '../SolutionHelpers';
import { colors } from '../../global/variables';
import { metersToKilometers, metersToMiles, secondsToHours, secondsToMinutes } from '../converter';

export const getGeoInfoFromObjects = (objList) =>
  objList && {
    type: 'FeatureCollection',
    features: Object.keys(objList)
      .filter((key) => objList[key]?.geo)
      .map((key) => objList[key].geo.map((feature) => feature))
      .flat(),
  };

export const getOriginalLines = (objList) =>
  objList && {
    type: 'FeatureCollection',
    features: Object.values(objList).flatMap((value) => value.originalLocation),
  };

export const formatSegmentDuration = (seconds) => {
  if (seconds == null) return null;
  const totalHours = secondsToHours(seconds);
  const h = Math.floor(totalHours);
  const m = Math.round((totalHours - h) * 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
};

export const formatSegmentDistance = (meters, isImperial) => {
  if (meters == null) return null;
  if (isImperial) return `${metersToMiles(meters).toFixed(1)} mi`;
  return `${metersToKilometers(meters).toFixed(1)} km`;
};

export const onEachFeature = (
  feature,
  layer,
  mapData,
  display,
  tourData,
  onTourLineClick,
  onToggleHiddenSegment,
  isImperial,
) => {
  if (feature.geometry.type === 'LineString') {
    const tour = mapData?.geo?.features.find(
      (f) =>
        f.geometry.type === 'LineString' &&
        (display.selectedTour !== undefined
          ? display.selectedTour === f.properties.routeId
          : includes(display.routeIds, f.properties.routeId)),
    );
    if (tour) {
      const { isStopsRequest, fromStop, segmentDuration, segmentDistance, segmentBaseDuration } =
        feature.properties;

      const distance = formatSegmentDistance(segmentDistance, isImperial);
      const duration = formatSegmentDuration(segmentDuration);
      const baseDuration = formatSegmentDuration(segmentBaseDuration);

      const durationMins =
        segmentDuration != null ? Math.floor(secondsToMinutes(segmentDuration)) : null;
      const baseMins =
        segmentBaseDuration != null ? Math.floor(secondsToMinutes(segmentBaseDuration)) : null;
      const delayMins = durationMins != null && baseMins != null ? durationMins - baseMins : null;
      const delayText =
        delayMins != null && delayMins > 0
          ? `<tr>
               <td>Delay</td>
               <td>+${delayMins}m</td>
             </tr>`
          : '';

      const segmentRows =
        isStopsRequest && distance != null && duration != null
          ? `
           <tr><td colspan="2"><hr style="margin:4px 0;border-color:${
             colors.primaryBorderColor
           }"/></td></tr>
           <tr><td>Stop</td><td>${fromStop} → ${fromStop + 1}</td></tr>
           <tr><td>Distance</td><td>${distance}</td></tr>
           <tr><td>Drive time</td><td>${duration}</td></tr>
           ${delayText}
           ${
             baseDuration && baseDuration !== duration
               ? `<tr><td style="color:${colors.primaryTextColor}">Free flow</td><td style="color:${colors.primaryTextColor}">${baseDuration}</td></tr>`
               : ''
           }
          `
          : '';

      layer.bindTooltip(
        `
          <table>
           <tr><td>Tour</td><td>${tour.properties.routeId + 1}</td></tr>
           <tr><td>Start</td><td>${moment(getTourStart(tour.properties.vehicle.id, tourData.tours))
             .utc()
             .format('LT')}</td></tr>
           <tr><td>End</td><td>${moment(getTourEnd(tour.properties.vehicle.id, tourData.tours))
             .utc()
             .format('LT')}</td></tr>
           ${segmentRows}
          </table>
        `,
        { sticky: true },
      );
      layer.on({
        click: () => onTourLineClick(feature),
        contextmenu: () => onToggleHiddenSegment && onToggleHiddenSegment(feature),
      });
    }
  }
};
